<template>
  <div
    class="modal"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
          >
            New Machine
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <machine-form :sections="sections" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MachineForm from '../../../forms/MachineForm';
export default {
  name: 'NewMachineModal',
  components: { MachineForm },
  props: {
    sections: {
      type: Array,
      default: () => []
    }
  }
};
</script>
